export default __webpack_public_path__ + "static/media/pickup.cda9f701.png";